import { PopoverContent, PopoverTrigger, Popover, Button } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { Info } from '@ui/components/icons';
import { Help } from '@shared/components';
import { FC } from 'react';

export const OnboardingHelp: FC = () => {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost">
          <Info />
          {t('HELP.HELP')}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="min-w-100" align="end">
        <Help />
      </PopoverContent>
    </Popover>
  );
};
